import React from 'react'
import SarasTrans from '../../../library/notifications/SarasTrans';

//starting with capital letter will ensure this is treated as a component
const InvGridItemH = ({col}) => {

    return (
        <div className="uiSearchSubList">
            <span className="sItemCode uiCenter"><SarasTrans value="Item Code" /></span>
            <span className="sItemID uiCenter"><SarasTrans value="Item Name" /></span>
            <span className="sItemWeight uiCenter"><SarasTrans value="Qty" /></span>
        </div>
    );
}

export default InvGridItemH
